import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ButtonBaseComponent } from './button-base.component';


@Component({
	selector: 'app-delete-button',
	templateUrl: './CoreButtonRaised.html'
})
export class DeleteButtonComponent extends ButtonBaseComponent {
	@HostBinding('class') class = 'adn-material-button';

	@Input()
	public iconClass = 'fa-trash';
	@Input()
	public titleTranslateKey = 'button.delete';
	@Input()
	public color = 'warn';
	@Input()
	public disabled: boolean = false;

	@Input()
	public type = 'button';

	@Input()
	public hintTranslateKey: string;


	@Output()
	action: EventEmitter<ButtonBaseComponent> = new EventEmitter<ButtonBaseComponent>();
}